import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconVQTextCheck = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M4.39656 7.93746L2.31156 5.85246L1.60156 6.55746L4.39656 9.35246L10.3966 3.35246L9.69156 2.64746L4.39656 7.93746Z"
      fill="#555555"
    />
  </SVG>
)
export default withIconStyles(IconVQTextCheck)
